import request from '@/utils/request'

export function submitQuot(param) {
  let data = param
  return request({
    url: `/quotation/epms1020/submitQuot`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}

export function getEpms7020(param) {
  let data = param
  return request({
    url: `/quotation/epms1020/getEpms7020`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa1020copy(param) {
  let data = param
  return request({
    url: `/quotation/epms1020/epmsa1020copy`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa1020ShipLoad(param) {
  let data = param
  return request({
    url: `/quotation/epms1020/epmsa1020ShipLoad`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function checkRemainShip(param) {
  let data = param
  return request({
    url: `/quotation/epms1020/checkRemainShip`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}